var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from '@ember/service';
import { mapBy } from 'ilios-common/utils/array-helpers';
let PermissionMatrixService = (_class = class PermissionMatrixService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "_permissionMatrixPromise", null);
  }
  async getPermissionMatrix() {
    if (!this._permissionMatrixPromise) {
      this._permissionMatrixPromise = this._fillMatrix();
    }
    return await this._permissionMatrixPromise;
  }
  async _fillMatrix() {
    const schools = await this.store.findAll('school');
    const schoolIds = mapBy(schools, 'id');
    const matrix = {};
    schoolIds.forEach(id => {
      matrix[id] = {
        CAN_UPDATE_SCHOOLS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_CREATE_PROGRAMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UPDATE_ALL_PROGRAMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_THEIR_PROGRAMS: ['PROGRAM_DIRECTOR'],
        CAN_DELETE_ALL_PROGRAMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_DELETE_THEIR_PROGRAMS: ['PROGRAM_DIRECTOR'],
        CAN_CREATE_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UPDATE_ALL_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_THEIR_PROGRAM_YEARS: ['PROGRAM_DIRECTOR'],
        CAN_DELETE_ALL_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_DELETE_THEIR_PROGRAM_YEARS: ['PROGRAM_DIRECTOR'],
        CAN_UNLOCK_ALL_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UNLOCK_THEIR_PROGRAM_YEARS: ['PROGRAM_DIRECTOR'],
        CAN_LOCK_ALL_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_LOCK_THEIR_PROGRAM_YEARS: ['PROGRAM_DIRECTOR'],
        CAN_UNARCHIVE_ALL_PROGRAM_YEARS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UNARCHIVE_THEIR_PROGRAM_YEARS: ['PROGRAM_DIRECTOR'],
        CAN_CREATE_COURSES: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_ALL_COURSES: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UPDATE_THEIR_COURSES: ['COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR'],
        CAN_DELETE_ALL_COURSES: ['SCHOOL_ADMINISTRATOR'],
        CAN_UNLOCK_ALL_COURSES: ['SCHOOL_ADMINISTRATOR'],
        CAN_UNLOCK_THEIR_COURSES: ['COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR'],
        CAN_UNARCHIVE_ALL_COURSES: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_SESSIONS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR', 'COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR'],
        CAN_UPDATE_ALL_SESSIONS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR'],
        CAN_UPDATE_THEIR_SESSIONS: ['SESSION_ADMINISTRATOR', 'SESSION_INSTRUCTOR'],
        CAN_DELETE_ALL_SESSIONS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_CREATE_COMPETENCIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_COMPETENCIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_DELETE_COMPETENCIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_SESSION_TYPES: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_SESSION_TYPES: ['SCHOOL_ADMINISTRATOR'],
        CAN_DELETE_SESSION_TYPES: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_VOCABULARIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_VOCABULARIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_DELETE_VOCABULARIES: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_TERMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_TERMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_DELETE_TERMS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_CREATE_INSTRUCTOR_GROUPS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR', 'COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR'],
        CAN_UPDATE_INSTRUCTOR_GROUPS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR', 'PROGRAM_DIRECTOR', 'COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR'],
        CAN_DELETE_INSTRUCTOR_GROUPS: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_LEARNER_GROUPS: ['SCHOOL_ADMINISTRATOR', 'COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR', 'SESSION_ADMINISTRATOR'],
        CAN_UPDATE_LEARNER_GROUPS: ['SCHOOL_ADMINISTRATOR', 'COURSE_ADMINISTRATOR', 'COURSE_DIRECTOR', 'SESSION_ADMINISTRATOR'],
        CAN_DELETE_LEARNER_GROUPS: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_CURRICULUM_INVENTORY_REPORTS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_ALL_CURRICULUM_INVENTORY_REPORTS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_UPDATE_THEIR_CURRICULUM_INVENTORY_REPORTS: ['CURRICULUM_INVENTORY_REPORT_ADMINISTRATOR'],
        CAN_DELETE_THEIR_CURRICULUM_INVENTORY_REPORTS: ['CURRICULUM_INVENTORY_REPORT_ADMINISTRATOR'],
        CAN_DELETE_ALL_CURRICULUM_INVENTORY_REPORTS: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_SCHOOL_CONFIGS: ['SCHOOL_ADMINISTRATOR', 'SCHOOL_DIRECTOR'],
        CAN_CREATE_CURRICULUM_INVENTORY_INSTITUTIONS: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_CURRICULUM_INVENTORY_INSTITUTIONS: ['SCHOOL_ADMINISTRATOR'],
        CAN_DELETE_CURRICULUM_INVENTORY_INSTITUTIONS: ['SCHOOL_ADMINISTRATOR'],
        CAN_CREATE_USERS: ['SCHOOL_ADMINISTRATOR'],
        CAN_UPDATE_USERS: ['SCHOOL_ADMINISTRATOR'],
        CAN_DELETE_USERS: ['SCHOOL_ADMINISTRATOR']
      };
    });
    return matrix;
  }
  async hasPermission(school, capability, userRoles) {
    const matrix = await this.getPermissionMatrix();
    const schoolId = school.get('id');
    if (!Object.prototype.hasOwnProperty.call(matrix, schoolId)) {
      return false;
    }
    const schoolMatrix = matrix[schoolId];
    if (!Object.prototype.hasOwnProperty.call(schoolMatrix, capability)) {
      return false;
    }
    const matchedRoles = schoolMatrix[capability].filter(role => userRoles.includes(role));
    return matchedRoles.length > 0;
  }
  async getPermittedRoles(school, capability) {
    const matrix = await this.getPermissionMatrix();
    const schoolId = school.get('id');
    if (!Object.prototype.hasOwnProperty.call(matrix, schoolId)) {
      return [];
    }
    const schoolMatrix = matrix[schoolId];
    if (!Object.prototype.hasOwnProperty.call(schoolMatrix, capability)) {
      return [];
    }
    return schoolMatrix[capability];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PermissionMatrixService as default };